import { canPullFocusAtom } from "@/modules/ui/can-pull-focus.atom";

/**
 * This atom is used to determine if the channel list is allowed to be opened or not.
 */
export const isChannelListAllowedAtom = canPullFocusAtom;
